import React from 'react';
import { View } from 'react-native';
import Button from 'src/components/Button/Button';
import { styles } from '../screens/QuoteScreen.styles';

interface ActionButtonsProps {
  onBack: () => void;
  onPurchase: () => void;
  isPurchaseDisabled: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onBack,
  onPurchase,
  isPurchaseDisabled,
}) => (
  <View style={styles.buttonContainer}>
    <Button
      type="tertiary"
      size="big"
      colorVariant="default"
      title="Back"
      onPress={onBack}
      style={styles.backButton}
    />
    <Button
      type="primary"
      size="big"
      colorVariant={isPurchaseDisabled ? 'disabled' : 'default'}
      title="Purchase"
      onPress={onPurchase}
      disabled={isPurchaseDisabled}
      style={styles.purchaseButton}
    />
  </View>
);

export default ActionButtons;
